/**
 * Mutual exclusion lock
 */
class Mutex {
  private mutex = Promise.resolve();

  /**
   * Run `fn` only if the lock is available, if it's not wait for it.
   * @param fn the function that requires the lock to run.
   * @returns a promise with the result of the requested operation.
   */
  public async run<T>(fn: () => Promise<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      this.mutex = this.mutex.then(async () => {
        try {
          resolve(await fn());
        } catch (err) {
          reject(err);
        }
      });
    });
  }
}

export default Mutex;
